<div>
  <h3>Applications</h3>
  <app-nav-grid></app-nav-grid>
</div>
<div style="font-size: 0.8em">
  <p><mat-icon inline>info</mat-icon>&nbsp;&nbsp;<i>To open the apps menu, click the apps icon <mat-icon inline>apps</mat-icon> in the upper right hand corner.</i></p>
  <p><mat-icon inline>info</mat-icon>&nbsp;&nbsp;<i>Right-click on an app to open in a new tab.</i></p>
</div>